import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useAuth } from "./AuthProvider";
import { withOrgSlug } from "../lib/customerUrl";

/**
 * Keep /apps/{app}/{slug}/... in the address bar. Legacy /apps/crm/companies
 * URLs and a mismatched slug are rewritten to this session's slug — the URL
 * never switches organizations (identity-first login).
 */
export function TenantAppRedirect({ children }: { children: ReactNode }) {
  const { session } = useAuth();
  const location = useLocation();
  const slug = session?.orgSlug;
  if (!slug) {
    return <Navigate to="/dashboard" replace />;
  }
  const next = withOrgSlug(location.pathname, slug);
  if (next !== location.pathname) {
    return <Navigate to={`${next}${location.search}${location.hash}`} replace />;
  }
  return <>{children}</>;
}
